module.exports = __webpack_public_path__ + "static/media/06_Portfolio.1a462fb3.png";